export default __webpack_public_path__ + "static/media/react-r-bg.8cb32dcb.png";